import axios from '../utils/axios';

export default function bulkActivateRecruiters (adminId, data) {
    return axios.post(`/admin/${adminId}/recruiter-bulk-activate`, data);
};